var map = {
	"./bialystok/podatek-rolny/section-2_pl.mdx": [
		34317,
		34317
	],
	"./bydgoszcz/podatek-rolny/section-2_pl.mdx": [
		24602,
		24602
	],
	"./czestochowa/podatek-rolny/section-2_pl.mdx": [
		13091,
		13091
	],
	"./garwolin/podatek-rolny/section-2_pl.mdx": [
		89000,
		89000
	],
	"./gdansk/podatek-rolny/section-2_pl.mdx": [
		69437,
		69437
	],
	"./gdynia/podatek-rolny/section-2_pl.mdx": [
		91613,
		91613
	],
	"./gliwice/podatek-rolny/section-2_pl.mdx": [
		7381,
		7381
	],
	"./gmina-swidnica/podatek-rolny/section-2_pl.mdx": [
		22068,
		22068
	],
	"./kielce/podatek-rolny/section-2_pl.mdx": [
		59582,
		59582
	],
	"./kolobrzeg/podatek-rolny/section-2_pl.mdx": [
		31296,
		31296
	],
	"./konskowola/podatek-rolny/section-2_pl.mdx": [
		55341,
		55341
	],
	"./koszalin/podatek-rolny/section-2_pl.mdx": [
		5670,
		5670
	],
	"./lask/podatek-rolny/section-2_pl.mdx": [
		30242,
		30242
	],
	"./lodz/podatek-rolny/section-2_pl.mdx": [
		62532,
		62532
	],
	"./lublin/podatek-rolny/section-2_pl.mdx": [
		93741,
		93741
	],
	"./miejsce-piastowe/podatek-rolny/section-2_pl.mdx": [
		37760,
		37760
	],
	"./mikolow/podatek-rolny/section-2_pl.mdx": [
		37085,
		37085
	],
	"./naklo/podatek-rolny/section-2_pl.mdx": [
		73320,
		73320
	],
	"./oborniki/podatek-rolny/section-2_pl.mdx": [
		99430,
		99430
	],
	"./olesnica/podatek-rolny/section-2_pl.mdx": [
		27861,
		27861
	],
	"./postomino/podatek-rolny/section-2_pl.mdx": [
		83777,
		83777
	],
	"./poznan/podatek-rolny/section-2_pl.mdx": [
		13705,
		13705
	],
	"./przechlewo/podatek-rolny/section-2_pl.mdx": [
		19814,
		19814
	],
	"./radom/podatek-rolny/section-2_pl.mdx": [
		82568,
		82568
	],
	"./raszkow/podatek-rolny/section-2_pl.mdx": [
		42612,
		42612
	],
	"./rawicz/podatek-rolny/section-2_pl.mdx": [
		36759,
		36759
	],
	"./ryman/podatek-rolny/section-2_pl.mdx": [
		92332,
		92332
	],
	"./sierakowice/podatek-rolny/section-2_pl.mdx": [
		20771,
		20771
	],
	"./slawno/podatek-rolny/section-2_pl.mdx": [
		41627,
		41627
	],
	"./slawoborze/podatek-rolny/section-2_pl.mdx": [
		85417,
		85417
	],
	"./stare-babice/podatek-rolny/section-2_pl.mdx": [
		87449,
		87449
	],
	"./szczecin/podatek-rolny/section-2_pl.mdx": [
		6580,
		6580
	],
	"./szemud/podatek-rolny/section-2_pl.mdx": [
		7409,
		7409
	],
	"./warszawa/podatek-rolny/section-2_pl.mdx": [
		83357,
		83357
	],
	"./wloszczowa/podatek-rolny/section-2_pl.mdx": [
		22106,
		22106
	],
	"./wroclaw/podatek-rolny/section-2_pl.mdx": [
		84890,
		84890
	],
	"./wyszkow/podatek-rolny/section-2_pl.mdx": [
		45567,
		45567
	],
	"./zukowo/podatek-rolny/section-2_pl.mdx": [
		60022,
		60022
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 41720;
module.exports = webpackAsyncContext;